import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'

import 'lazysizes';

import gridOverlay from './gridOverlay'

class DropOff {

	constructor() {
		
        this.siteHeader = document.querySelector('.site-header')
		this.toggleMenuButton = document.querySelector('.site-header__toggle-menu-button')

	}
    toggleButton() {
        
        const toggleButton = document.querySelector('.siteheader__toggle-button')
        const header = document.querySelector('.siteheader')

        toggleButton.addEventListener('click', () => {
            header.classList.toggle('siteheader--open-menu')
        })
    }
    countyDropdown() {
        const button = document.getElementsByClassName('county-dropdown__button')[0]
        const content = document.getElementsByClassName('county-dropdown__content')[0]

        button.addEventListener('click', () => {
        content.classList.toggle('active')
        })
    }
    countySelect () {
        const countySelectForm = document.querySelector('.countySelectForm');
        const countySelect = document.querySelector('.countySelectForm__select');
        const submit = document.querySelector('.countySelectForm__submitBtn');

        if (countySelect) {
            countySelect.addEventListener("change", function(event) {
                submit.click();
            });
        }        
        if (countySelectForm) {
            countySelectForm.addEventListener("submit", function(event) {
                event.preventDefault();
                window.location.href = countySelect.value;
            });
        }
    }
    //To fix transition bug where siteheader blinks on load
    preload () {
        const body = document.querySelector('.preload');

        window.addEventListener("load", function(event){
            body.classList.remove("preload");
        });
    }
	init() {

        this.toggleButton()
        this.countySelect()
        this.preload()
	}
}
const site = new DropOff();
site.init();
